
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { createClient, getUserApiKey } from '@/lib/supabase-client'
import { type UserProfile } from '../types'
import Sidebar from './Sidebar'
import DashboardHeader from './DashboardHeader'
import BatchUploader from './BatchUploader'

export default function BatchPage() {
  const [profile, setProfile] = useState<UserProfile | null>(null)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const supabase = createClient()

  useEffect(() => {
    loadData()
  }, [])

  const loadData = async () => {
    const { data: { session } } = await supabase.auth.getSession()
    if (!session) {
      navigate('/auth/login')
      return
    }

    const { data: profileData } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', session.user.id)
      .single()

    const apiKey = await getUserApiKey(supabase, session.user.id)

    if (profileData) {
      setProfile({
        ...profileData,
        email: session.user.email || '',
        api_key: apiKey || '',
      } as UserProfile)
    }

    setLoading(false)
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-white dark:bg-slate-900 flex items-center justify-center">
        <div className="text-center animate-fade-in">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 dark:border-primary-400"></div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 dark:from-slate-900 dark:via-slate-900 dark:to-slate-800">
      <Sidebar />
      <div className="lg:pl-64">
        <DashboardHeader title="Batch Generator" />
        <main className="px-4 sm:px-6 lg:px-8 py-8">
          <div className="mb-8 animate-fade-in">
            <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2">Batch Generator</h1>
            <p className="text-lg text-gray-600 dark:text-gray-400">Generate alt text for multiple images at once</p>
          </div>
          {profile && profile.api_key ? (
            <BatchUploader apiKey={profile.api_key} />
          ) : (
            <div className="glass-card rounded-xl p-6 text-center">
              <p className="text-gray-600 dark:text-gray-400">Loading API key...</p>
            </div>
          )}
        </main>
      </div>
    </div>
  )
}

